import LegalPage from "./LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      testId="privacy-page"
      title="Privacy"
      accent="Policy."
      effective="January 25, 2026"
      sections={[
        {
          heading: "GLBA Privacy Notice",
          body: [
            { html: 'Our GLBA Privacy Notice (the federal financial privacy disclosure) is available <a href="/privacy/glba" class="text-jc-gold underline decoration-jc-gold/40 hover:decoration-jc-gold">here</a>.' },
          ],
        },
        {
          heading: "Company Disclosure",
          body: [
            "JC3 Wealth Legacy Group LLC is a financial consulting firm. We do not guarantee specific results. Individual outcomes vary based on your financial profile, third-party institution criteria, and client cooperation. We are not a credit repair organization and we are not a lender or funding company.",
          ],
        },
        {
          heading: "Overview",
          body: [
            'JC3 Wealth Legacy Group LLC ("JC3," "we," "us," or "our") operates jc3wealthlegacy.com and billionairejace.com. This Privacy Policy explains how we collect, use, disclose, and protect your information when you visit our websites, request a consultation, or engage our services.',
          ],
        },
        {
          heading: "Information We Collect",
          body: ["We collect the following categories of information:"],
          bullets: [
            "Information you submit through forms: name, email address, phone number, city and state",
            "Business information you share during a consultation or onboarding (entity type, financial profile context, goals)",
            "Payment information collected through our secure payment processor — we do not store payment card details on our systems",
            "Technical information: IP address, browser type, operating system, device characteristics, and pages visited (collected via Google Analytics 4)",
            "Cookies and similar technologies used to support analytics and remember preferences",
          ],
        },
        {
          heading: "How We Use Your Information",
          body: ["We use your information for the following purposes:"],
          bullets: [
            "Delivering the services you have requested",
            "Communicating with you about your account, consultation, or service engagement",
            "Processing payments through our payment processor",
            "Marketing communications (with the option to opt out at any time)",
            "Website analytics and improvement",
            "Compliance with applicable legal and regulatory obligations",
          ],
        },
        {
          heading: "Sharing of Information",
          body: [
            "We do not sell personal information. We share information only with service providers who are bound by data-protection agreements and who help us deliver our services.",
            "Current service providers include: Airtable (client records), Resend (transactional email), PaymentCloud (payment processing), Authorize.net (payment tokenization), Google Analytics 4 (anonymized site analytics), and GoHighLevel (scheduling and client communications).",
          ],
        },
        {
          heading: "Cookies and Tracking",
          body: [
            "We use Google Analytics 4 with IP anonymization for aggregate visitor analytics. You can opt out of Google Analytics tracking by installing the Google Analytics Opt-Out Browser Add-on at tools.google.com/dlpage/gaoptout.",
          ],
        },
        {
          heading: "Text Messages and Calls",
          body: [
            "If you give consent, we may call or text you about your account, appointments, and our services, including with automated technology. Consent is not a condition of purchase. Message and data rates may apply. Message frequency varies. Reply STOP to opt out or HELP for help.",
            "We do not sell or share your mobile number or text messaging consent with third parties or affiliates for their marketing purposes.",
          ],
        },
        {
          heading: "Data Retention",
          body: [
            "We retain client records for a minimum of three (3) years after the end of an engagement to satisfy legal, accounting, and tax obligations. Marketing data is retained until you opt out.",
          ],
        },
        {
          heading: "Your Rights",
          body: ["You have the right to:"],
          bullets: [
            "Access the personal information we hold about you",
            "Correct inaccurate information",
            "Request deletion of your information, subject to legal retention requirements",
            "Opt out of marketing communications at any time",
            "Request a portable copy of your information",
          ],
        },
        {
          heading: "Data Security",
          body: [
            "We protect your information using SSL encryption in transit, payment tokenization via Authorize.net, role-based access controls, and routine security review of our internal systems.",
          ],
        },
        {
          heading: "Minors",
          body: [
            "Our services are not directed to and we do not knowingly collect personal information from individuals under the age of 18.",
          ],
        },
        {
          heading: "Contact",
          body: [
            { html: 'For privacy questions or requests, contact us at <a class="text-jc-gold underline decoration-jc-gold/40 hover:decoration-jc-gold" href="mailto:jace@jc3wealthlegacy.com">jace@jc3wealthlegacy.com</a> or via <a class="text-jc-gold underline decoration-jc-gold/40 hover:decoration-jc-gold" href="https://jc3wealthlegacy.com">jc3wealthlegacy.com</a>.' },
            { html: 'JC3 Wealth Legacy Group LLC · Atlanta, Georgia · <a class="text-jc-gold underline decoration-jc-gold/40 hover:decoration-jc-gold" href="tel:+14708887331">470-888-7331</a>' },
          ],
        },
      ]}
    />
  );
}
